import React from 'react';
import { useTranslation } from 'react-i18next';

export interface GameListTableViewSwitcherProps {
  groupBy: 'games' | 'sku';
  setGroupBy: (value: 'games' | 'sku') => void;
}

function GameListTableViewSwitcher({ groupBy, setGroupBy }: GameListTableViewSwitcherProps) {
  const { t } = useTranslation();

  return (
    <>
      <button
        className={`btn btn-${
          groupBy === 'games' ? 'primary' : 'default'
        } btn-outline r-corners-left`}
        onClick={(e) => {
          setGroupBy('games');
        }}
        title={t('Games')}
      >
        {t('Games')}
      </button>
      <button
        className={`btn btn-${
          groupBy === 'sku' ? 'primary' : 'default'
        } btn-outline r-corners-right`}
        onClick={(e) => {
          setGroupBy('sku');
        }}
        title={t('Games + SKU')}
      >
        {t('Games + SKU')}
      </button>
    </>
  );
}

export default GameListTableViewSwitcher;
